import  'jquery.cookie';
jQuery(function($){
	$.cookie.json = true;
	$.fn.saveForm = function(){
		const selector = '.wp-block-webfactory-field input[name], .wp-block-webfactory-field select[name]'
		let cookieKey = 'wf-form-'+$(this).attr('id');
		let $form = $(this);
		let getValue = function(){
			let data = {};
			$form.find(selector).each(function(){
				data[$(this).attr('name')] = $(this).val();	
			})
			return data;
		}

		let setValue = function(data){
			if (!data){
				return 
			}

			$form.find(selector).each(function(){
				let name = $(this).attr('name');
				let val = data[name];
				if ($(this).is('[type="file"]')){
					return;
				}
				if ($(this).is('[type="checkbox"]')){
					$(this).prop('checked', val?true:false)
					return;
				}
				if ($(this).is('[type="radio"]')){
					let v = $(this).attr('value');
					$(this).prop('checked', v==val)
					return;
				}
				if (val === undefined){
					return;
				}
				$(this).val(val).trigger('field.value.change')
				if (this.selectize){
					this.selectize.setValue(val)
				}
			})
		}

		let storeValue = function(){
			$.cookie(cookieKey, getValue())
		}

		let restoreValue = function(){
			setValue($.cookie(cookieKey))
		}

		$(this).on('change, input', selector, function(){
			storeValue()
		})
		restoreValue();

	}
	$(document).ready(function(){
		$('form[data-save="cookies"]').each(function(){
			$(this).saveForm();
		})
	});
})